import { render, staticRenderFns } from "./main-fluid.vue?vue&type=template&id=7700c4de&"
import script from "./main-fluid.vue?vue&type=script&lang=js&"
export * from "./main-fluid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports